import React from 'react';
import './RewardCard.css';

const RewardCard = ({ reward, user, onRedeem }) => {
  const handleRedeem = () => {
    if (onRedeem) {
      onRedeem(reward);
    }
  };

  const canRedeem = user?.pointsBalance >= reward.pointCost && reward.stock !== 0;

  // Format point cost to show dollar equivalent
  const formatPointCost = (points) => {
    const dollars = points / 10000; // 10,000 points = $1 USD
    return `USD ${dollars.toFixed(0)}`;
  };

  return (
    <div className="reward-card">
      <div className="reward-image-container">
        {reward.image ? (
          <img src={reward.image} alt={reward.name} className="reward-card-image" />
        ) : (
            <div className="reward-icon-placeholder">
            {reward.type === 'gift_card' && '🎁'}
            {reward.type === 'cash' && '💰'}
            {reward.type === 'coupon' && '🎫'}
            {reward.type === 'product' && '📦'}
            </div>
        )}
      </div>
      
      <div className="reward-content">
        <h3 className="reward-name">{reward.name}</h3>
        <p className="reward-description">{reward.description}</p>

        <div className="reward-meta">
          <div className="reward-cost">
            <span className="cost-icon">⭐</span>
            <span className="cost-value">{reward.pointCost} points</span>
          </div>

          <div className="reward-type">
            <span className="type-badge">{reward.type.replace('_', ' ')}</span>
          </div>
        </div>

        {reward.stock !== -1 && (
          <div className="reward-stock">
            <span className="stock-label">Stock:</span>
            <span className={`stock-value ${reward.stock === 0 ? 'out-of-stock' : ''}`}>
              {reward.stock === 0 ? 'Out of Stock' : `${reward.stock} left`}
            </span>
          </div>
        )}

        <div className="reward-actions">
          {user?.role === 'respondent' ? (
            <button
              onClick={handleRedeem}
              className={`btn ${canRedeem ? 'btn-primary' : 'btn-ghost'}`}
              disabled={!canRedeem}
            >
              {canRedeem ? 'Redeem Now' : 'Insufficient Points'}
            </button>
          ) : (
            <div className="reward-info">
              <span className="info-text">Login to redeem</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RewardCard;
